import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=692187ca&scoped=true&"
import script from "./CourseDetail.ts?vue&type=script&lang=js&"
export * from "./CourseDetail.ts?vue&type=script&lang=js&"
import style0 from "./CourseDetail.less?vue&type=style&index=0&id=692187ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692187ca",
  null
  
)

export default component.exports